<template>
    <div class="popup__overlay" id="popupContainer" ref="AppWapper">
        <div class="campaign__popup" id="popupHolder">
            <div>
                <!-- Header with status -->
                <div class="popup__header">
                  <div class="popup__header-info">
                    <p>{{ activeCampaign.name }} Campaign Stats</p>
                    <span v-if="activeCampaign.status" :class="activeCampaign.status + '__status'" style="cursor: pointer;" @click="campaignStatusChanger">{{ activeCampaign.status.toUpperCase() }}</span>
                    <div v-if="statusChange" id="status-change" @focusout="removeStatusBox" tabindex="1" class="status__context status__style status__border">
                        <span class="button__style button__context btn__approve__campaign__color" @click="approveCampaign" v-bind:class="[ campaignApproval !== null && campaignApproval ? 'btn__approve__clicked' : '']">Approve</span>
                        <span class="button__style button__context btn__decline__campaign__color" @click="declineCampaign" v-bind:class="[ campaignApproval !== null && !campaignApproval ? 'btn__decline__clicked' : '']">Decline</span>
                    </div>
                  </div>
                  <!-- Controll buttons -->
                  <div class="control-btn-container popup__header-actions">
                    <div class="btn" @click="toggleCampaignStatus" :class="{'disabled-btn': activeUpdate}">
                          <clip-loader color="#2EA3FF" size="15px" :loading="activeUpdate" />
                          <p style="display: block;">{{ activeCampaign.active === "Y" ? 'Deactivate' : 'Activate' }}</p>
                      </div>
                      <div class="btn">
                          <div class="delete--btn" @click="deletePrompt=!deletePrompt">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash">
                                  <polyline points="3 6 5 6 21 6"></polyline>
                                  <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                              </svg>
                              <p>Delete Campaign</p>
                          </div>
                          <div class="btn-popup" v-if="deletePrompt">
                              <p>Are you sure?</p>
                              <div class="option-btn" @click="deleteCampaign">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check">
                                      <polyline points="20 6 9 17 4 12"></polyline>
                                  </svg>
                              </div>
                              <div class="option-btn" @click="deletePrompt=false">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x">
                                      <line x1="18" y1="6" x2="6" y2="18"></line>
                                      <line x1="6" y1="6" x2="18" y2="18"></line>
                                  </svg>
                              </div>
                          </div>
                      </div>
                      <div class="btn" @click="editCampaign">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit-2">
                              <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
                          </svg>
                          <p>Edit Campaign</p>
                      </div>

                      <div class="btn" @click="$emit('closePopup')">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x">
                              <line x1="18" y1="6" x2="6" y2="18"></line>
                              <line x1="6" y1="6" x2="18" y2="18"></line>
                          </svg>
                      </div>
                  </div>
                </div>

                <!-- Top boxes -->
                <div class="boxes__container">
                    <div class="box__container box-shadow">
                        <img src="./../../assets/active_driver.svg" />
                        <p class="label">Active Drivers</p>
                        <p class="value">{{ activeCampaign.active_drivers }}</p>
                    </div>
                    <div class="box__container box-shadow">
                        <img src="./../../assets/total_drivers.svg" />
                        <p class="label">Total Drivers</p>
                        <p class="value">{{ activeCampaign.total_drivers }}</p>
                    </div>
                    <div class="box__container box-shadow">
                        <img src="./../../assets/impressions.svg" />
                        <p class="label">Impressions</p>
                        <p class="value">{{ activeCampaign.impressions }}</p>
                    </div>
                    <div class="box__container box-shadow">
                        <img src="./../../assets/impressions.svg" />
                        <p class="label">Real time impressions</p>
                        <p class="value">{{ activeCampaign.RT_impressions }}</p>
                    </div>
                    <div class="box__container box-shadow">
                        <img src="./../../assets/display_count.svg" style="width: 60px;"/>
                        <p class="label">Display Count</p>
                        <p class="value">{{ activeCampaign.show_count }}</p>
                    </div>
                    <div class="box__container box-shadow">
                        <img src="./../../assets/cost.svg" style="width: 45px;"/>
                        <p class="label">Cost</p>
                        <p class="value">{{ activeCampaign.spent }}</p>
                    </div>
                </div>

                <!-- Overview -->
                <div class="campaign__overview box-shadow">
                    <p class="overview__header">OVERVIEW OF CAMPAIGN</p>
                    <div class="campaign_left">
                        <video
                            v-if="isVideoContent(activeCampaign.content_url)"
                            :src="activeCampaign.content_url"
                            controls
                            playsinline
                            preload="metadata"
                        ></video>
                        <img v-else :src="activeCampaign.content_url"/>
                    </div>
                    <div class="campaign__top__row">

                        <div class="campaign__pair">
                            <p class="label">TOTAL BUDGET</p>
                            <p class="value" v-if="activeCampaignReport.info">${{ activeCampaignReport.info[0].budget }}</p>
                        </div>
                        <div class="campaign__pair">
                            <p class="label">DEVICE GROUP</p>
                            <p class="value">{{activeCampaign.device_group || '-'}}</p>
                        </div>
                        <div class="campaign__pair" style="min-width: 26%;">
                            <p class="label">CAR TYPE</p>
                            <p class="value">{{carTypes}}</p>
                        </div>


                    </div>
                    <div class="campaign__bottom__row">
                        <p class="label">SCHEDULE</p>
                        <div class="campaign__pair__holder">
                            <div class="campaign__pair">
                                <p>Start date: {{ customUSFormatter(activeCampaign.start_date) }}</p>
                                <p>End date: {{ customUSFormatter(activeCampaign.end_date) }}</p>
                            </div>
                            <div class="campaign__pair">
                                <p>Start time: {{ activeCampaign.start_time }}</p>
                                <p>End time: {{ activeCampaign.end_time }}</p>
                            </div>
                            <div class="campaign__pair">
                                <p class="label">CYCLE DURATION</p>
                                <p class="value" v-if="activeCampaign.duration">{{ activeCampaign.duration }}</p>
                                <p>&nbsp;</p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Brief report -->
                <div class="box-shadow double__chart">
                    <p class="charts__header">Brief report</p>
                    <div class="charts__row">
                        <div class="chart__container">
                            <div class="chart" >
                                <apexchart type="line"  class="apx"  :options="dayChartOptions" :series="dayChartSeries"></apexchart>
                            </div>
                            <p>Impression distribution per day</p>
                        </div>
                        <div class="chart__container">
                            <div class="chart">
                                <apexchart type="line" class="apx" :options="hourChartOptions"  :series="hourChartSeries"></apexchart>
                            </div>
                            <p>Display time distribution per hour</p>
                        </div>


                    </div>

                      <div class="report-btn" @click="downloadReport">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-download">
                                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                <polyline points="7 10 12 15 17 10"></polyline>
                                <line x1="12" y1="15" x2="12" y2="3"></line>
                            </svg>
                            Download Full Report
                        </div><br/><br/><br/>


                </div>
                <!-- Maps -->
                <div class="maps__container box-shadow" >

                  <div style="display: flex">
                    <GmapMap
                        v-show="activeCampaign.lat"
                        :center="{lat: activeCampLat, lng: activeCampLon}"
                        :zoom="10"
                        ref="geofenceMap"
                        :options="{mapTypeControl: false, streetViewControl: false, styles, zoomControl: false, fullscreenControl: true,  gestureHandling: 'cooperative'}"
                        map-type-id="terrain"
                        style="width: 50%; margin: 15px; height: 300px"
                    >
                        <GmapCircle
                            ref="theCircle"
                            v-if="activeCampaign.ZIP_codes && activeCampaign.ZIP_codes.length === 0"
                            :center="{lat: activeCampaign.lat, lng: activeCampaign.lon}"
                            :radius="activeCampaign.distance"
                            :clickable="false"
                            :draggable="false"
                            :editable="false"
                            :options="{strokeColor: '#102130', strokeWeight: 2, fillColor: 'rgb(223, 242, 255)', fillOpacity: .5}"
                        />
                        <GmapPolygon v-for="(polygon, index) in computedPolygons"  :key="index" v-bind:path.sync="polygon" v-bind:options="{strokeColor: '#102130', strokeWeight: 2, fillColor: 'rgb(223, 242, 255)', fillOpacity: .5}"></GmapPolygon>
                    </GmapMap>

                    <heatmap
                      v-if="zipcodeHeatMapPoints"
                      class="admin-campaign-heatmap"
                      :center="{lat: activeCampLat, lng: activeCampLon}"
                      :initialPoints="zipcodeHeatMapPoints"
                      :needBound="zipcodeHeatMapPointsNeedBound"
                      @zoom-changed="zoomChangingZipcodeHeatMap"
                    />
                  </div>
                </div>
                <div class="box-shadow campaign__chart__container" style="display: flex">
                    <p class="overview__header">DATA</p>

                    <div class="chart__labels__holder">
                      <div class="chart__total__holder">TOTAL: <span>{{ this.totalFixed}}</span>
                      </div>
                        <div class="chart__type__holder">
                            <p :class="{'active__chart__label': activeChartType === 'RT_impressions'}" @click="setChartType('RT_impressions')">Impressions</p>
                            <p :class="{'active__chart__label': activeChartType === 'duration'}" @click="setChartType('duration')">Display Duration</p>
                            <p :class="{'active__chart__label': activeChartType === 'displays'}" @click="setChartType('displays')"># Of Cars</p>
                        </div>

                        <div class="chart__duration__holder">
                            <p :class="{'active__chart__label': activeChartDuration === 'hours'}" @click="setChartDuration('hours')">Hours</p>
                            <p :class="{'active__chart__label': activeChartDuration === 'days'}" @click="setChartDuration('days')">Days</p>
                        </div>
                    </div>

                    <div class="chart">
                        <apexchart class="apx" type="line" :options="chartOptions" :series="chartSeries"></apexchart>
                    </div>
                </div>

                <div class="heatmap__container maps__container box-shadow" style="padding: 15px;">
                    <p class="overview__header">FILTERED CAMPAIGN DATA</p>
                    <div class="filters__container">
                        <p class="header">FILTER</p>

                        <div class="filters__row flex ">
                            <v-date-picker mode="single" :masks="{ input: ['MM-DD-YYYY']}" :input-props='{class: "datepicker"}' v-model="filters.start_date" />
                            <el-time-picker
                                class="pick-time"
                                v-model="filters.start_time"
                                selectableRange="00:00 - 12:59"
                                format="hh:mm A"
                                value-format="HH:mm">
                            </el-time-picker>
                        </div>
                          <div class="filters__row flex ">
                            <v-date-picker mode="single" :masks="{ input: ['MM-DD-YYYY']}" :input-props='{class: "datepicker"}' v-model="filters.end_date" />
                            <el-time-picker
                                v-model="filters.end_time"
                                selectableRange="00:00 - 12:59"
                                format="hh:mm A"
                                value-format="HH:mm">
                            </el-time-picker>

                            <p class="apply-btn" @click="applyFilters(null)">Apply</p>
                        </div>
                    </div>

                    <div class="filtered__map__container">
<!--                        <Loading :class="{'fade__animation': mapAnimation}" v-if="mapLoading" />-->
                        <heatmap
                          v-if="campaignsHeatMapPoints"
                          class="campaigns-stats-heatmap"
                          :center="{ lat: activeCampLat, lng: activeCampLon }"
                          :initialPoints="campaignsHeatMapPoints"
                          :needBound="campaignsHeatMapPointsNeedBound"
                          @zoom-changed="zoomChangingFilteredCampaignStats"
                        />
                    </div>

                    <div class="filtered__chart__container chart__container">
                        <Loading :class="{'fade__animation': chartAnimation}" v-if="chartLoading" />
                        <div class="chart__labels__holder" style="margin-top: 25px;">
                            <div class="chart__total__holder">TOTAL: <span>{{ this.totalfilteredChart}}</span></div>
                            <div class="chart__type__holder">
                                <p :class="{'active__chart__label': filteredChartType === 'RT_impressions'}" @click="setFilteredChartType('RT_impressions')">Impressions</p>
                                <p :class="{'active__chart__label': filteredChartType === 'duration'}" @click="setFilteredChartType('duration')">Display Duration</p>
                                <p :class="{'active__chart__label': filteredChartType === 'displays'}" @click="setFilteredChartType('displays')"># Of Cars</p>
                            </div>

                            <div class="chart__duration__holder">
                                <p :class="{'active__chart__label': filteredChartDuration === 'hours'}" @click="setFilteredChartDuration('hours')">Hours</p>
                                <p :class="{'active__chart__label': filteredChartDuration === 'days'}" @click="setFilteredChartDuration('days')">Days</p>
                            </div>
                        </div>

                        <div class="chart">
                            <apexchart type="line" class="apx" :options="filteredChartOptions" :series="filteredChartSeries"></apexchart>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import styles from '@utils/mapStylesDark.js'
import Chart from '@utils/Chart.js'
import {gmapApi} from 'vue2-google-maps'
import toast from '@utils/toast'
import $ from 'jquery'
import moment from 'moment'
import store from '@store/index.js'

import { ERROR_CODE_INVALID_TOKEN } from '../../constants/responseCode'

import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import Datepicker from 'vuejs-datepicker'
import TimePicker from '@partials/TimePicker.vue'
import Loading from '@partials/Loading.vue'
import Heatmap from '@partials/Heatmap.vue'

export default {
    name: 'AdminCampaignPopup',
    components: {
        ClipLoader,
        Datepicker,
        TimePicker,
        Loading,
        Heatmap
    },
    data () {
        return {
            chartDrawSize:{redrawOnParentResize: true},
            deletePrompt: false,
            showInfo: false,
            activeUpdate: false,
            activeCampaign: {},
            activeCampLat: 0.0,
            activeCampLon: 0.0,
            activeCampaignReport: {},
            activeCampaignStats: {},
            filteredCampaignStats: {},
            hourChartOptions: {},
            dayChartOptions: {},
            chartOptions: {},
            filteredChartOptions: {},
            hourChartSeries: [],
            dayChartSeries: [],
            chartSeries: [],
            filteredChartSeries: [],
            geofenceMap: null,
            polygons: [],
            bounds: null,
            styles,
            activeChartType: '',
            activeChartDuration: '',
            filteredChartType: '',
            filteredChartDuration: '',
            chart: {
                days: [],
                hours: []
            },
            filteredChart: {
                days: [],
                hours: []
            },
            filters: {
                start_date: moment(moment().subtract(1, 'months').format('MM-DD-YYYY'), 'MM-DD-YYYY').toDate(),
                end_date: moment(moment().format('MM-DD-YYYY'), 'MM-DD-YYYY').toDate(),
                start_time: '00:00',
                end_time: '00:00'
            },
            mapLoading: false,
            chartLoading: false,
            mapAnimation: false,
            chartAnimation: false,
            statusChange: false,
            insideClick: true,
            campaignApproval: null ,
            store: store,
            categorieName: '',
            categorieMedia: '',
            carTypes: '',
            totalChart: 0,
            totalfilteredChart: 0,

            zipcodeHeatMapPoints: null,
            zipcodeHeatMapPointsNeedBound: false,
            campaignsHeatMapPoints: null,
            campaignsHeatMapPointsNeedBound: false
        }
    },
    methods: {
        setupCampaign() {
            this.getCampaign()
            this.getCampaignStats();
            this.getFilteredCampaignStats();
            this.getCampaignReport()
            this.getFilteredCampaignReport()
        },
        toggleCampaignStatus () {
          if(!this.activeUpdate){
              let url = '/set/campaign'
              let active = this.activeCampaign.active === "Y" ? "N" : "Y";
              this.activeUpdate = true
              let json = {
                  data: {...this.activeCampaign, campaign_id: this.activeCampaign.id, active},
                  API_KEY: this.store.getters.keys.api_key,
                  code: this.store.getters.getToken.token,
                  user: this.store.getters.getUser.user
              }
              this.request(url, 'POST', json).then((response)=>{
                  if (response.code === 0) {
                    this.activeCampaign.active = active;
                    toast.successMessage("Status updated successfully")
                  } else {
                    toast.errorMessage(`Code: ${response.code}. ${response.message}`)
                  }
                  this.activeUpdate = false
              }).catch(err=>{
                  this.activeUpdate = false
                  toast.errorMessage("Something went wrong")
              })
          }
        },
        deleteCampaign () {
          let url = '/delete/campaign'
          let body = {
              data: {
                  campaign_id: this.campaign.id
              }
          }
          this.request(url, 'POST', body).then(response=>{
              if(response.result === "success"){
                  this.$emit('onDelete')
                  toast.campaignDeleted();
                  this.$router.go(-1);
              } else {
                console.error(response.message);
                toast.custom(response.message, "error");
              }
          });
        },
        editCampaign () {
          this.$emit('closePopup')
          this.$router.push({name: 'EditCampaign', params: {id: this.activeCampaign.id}})
        },
        getCampaign () {
                var url = '/get/campaign'
                var body = {
                    data: {
                        campaign_id: this.campaign.id
                    }
                }

                this.request(url, 'POST', body).then(response=>{
                    if (response.code === 0) {
                        this.activeCampaign = response.data[0]
                        console.log(this.activeCampaign)
                        this.categorieName = this.setCategories(this.activeCampaign.category)
                        this.carTypes = this.setCarType(this.activeCampaign.car_types)
                        this.activeCampLat = parseFloat( this.activeCampaign.lat)
                        this.activeCampLon = parseFloat( this.activeCampaign.lon)
                        this.initGeofenceMap()
                        this.initStatus()
                    } else {
                        if (response.code === ERROR_CODE_INVALID_TOKEN) {
                            this.checkTokenConditions(this.getCampaign)
                        }
                    }
                })
        },
        initStatus () {
            this.campaignApproval = this.activeCampaign.status === "pending" ? null : this.activeCampaign.status === "approved" ? true : false
        },

        isVideoContent (url) {
            return /\.(mp4|mov|webm|ogg|ogv|m4v)(\?.*)?$/i.test(url || '')
        },

        fetchCampaignStats(zoom) {
          const url = '/get/campaign/stats'
          const body = {
            data: {
              campaign_id: this.campaign.id,
              zoom
            }
          }

          return this.request(url, 'POST', body)
        },

        fetchFilteredCampaignStats(zoom) {
          const url = '/get/campaign/stats'
          const from = moment(this.filters.start_date).format("YYYY-MM-DD") + " " + this.filters.start_time
          const till = moment(this.filters.end_date).format("YYYY-MM-DD") + " " + this.filters.end_time

          const body = {
            data: {
              campaign_id: this.campaign.id,
              zoom,
              from,
              till,
            }
          }

          return this.request(url, 'POST', body)
        },

        getCampaignStats(zoom) {
          this.fetchCampaignStats(zoom).then(response => {
              if (response.code === 0) {
                this.zipcodeHeatMapPoints = response.data.points?.coordinates || []
                this.zipcodeHeatMapPointsNeedBound = !zoom
              } else {
                  toast.errorMessage(response.message)
                  if(response.code === ERROR_CODE_INVALID_TOKEN) {
                    this.checkTokenConditions(this.getCampaignStats)
                  }
              }
          })
        },

        applyFilters() {
            this.getFilteredCampaignReport()
            this.getFilteredCampaignStats()
        },

        getFilteredCampaignStats (zoom) {
          this.mapLoading = true
          this.fetchFilteredCampaignStats(zoom).then(response => {
              if (response.code === 0){
                this.campaignsHeatMapPoints = response.data.points?.coordinates || []
                this.campaignsHeatMapPointsNeedBound = !zoom
                  setTimeout(()=>{
                      this.mapLoading = false
                      this.mapAnimation = false
                  }, 1000)
              } else {
                  toast.errorMessage(response.message)
                  if (response.code === ERROR_CODE_INVALID_TOKEN) {
                      this.checkTokenConditions(this.getFilteredCampaignStats)
                  }
              }
          })
        },

        getFilteredCampaignReport() {
                var url = '/get/campaign/report'
                var from = moment(this.filters.start_date).format("YYYY-MM-DD") + " " + this.filters.start_time
                var till = moment(this.filters.end_date).format("YYYY-MM-DD") + " " + this.filters.end_time
                var self = this
                this.chartLoading = true

                var body = {
                    data: {
                        campaign_id: this.campaign.id,
                        from,
                        till
                    }
                }

                this.request(url, 'POST', body).then(response=>{
                    if (response.code === 0) {
                        this.filteredChart.days = response.data[0].displays_by_weekday
                        this.filteredChart.hours = response.data[0].displays_by_hour
                        this.setFilteredChart()
                        this.chartAnimation = true
                        setTimeout(()=>{
                            self.chartLoading = false
                            self.chartAnimation = false
                        }, 1000)
                    } else {
                        toast.errorMessage(response.message)
                        if (response.code === ERROR_CODE_INVALID_TOKEN) {
                            this.checkTokenConditions(this.getFilteredCampaignReport)
                        }
                    }
                })
        },
        getCampaignReport () {
                var url = '/get/campaign/report'
                var body = {
                    data: {
                        campaign_id: this.campaign.id
                    }
                }

                this.request(url, 'POST', body).then(response=>{
                    if (response.code === 0) {
                        this.activeCampaignReport = response.data[0]

                        this.chart.days = response.data[0].displays_by_weekday
                        this.chart.hours = response.data[0].displays_by_hour
                        this.setDayChart()
                        this.setHourChart()
                        this.setChart()
                    } else {
                        toast.errorMessage(response.message)
                        if (response.code === ERROR_CODE_INVALID_TOKEN) {
                           this.checkTokenConditions(this.getCampaignReport)
                        }
                    }
                })
        },
        setDayChart () {
            let categories = []
            let series = []
            // change to day reports instead of hour reports
               this.activeCampaignReport.displays_by_weekday.map(obj=>{
                categories.push(obj.day)
                series.push(obj.RT_impressions)

            })


            // this.activeCampaignReport.displays_by_hour.map(obj=>{
            //     categories.push(obj.hour)
            //     series.push(obj.RT_impressions)


            // })

            if(this.isMobile()){
                this.dayChartOptions = Chart.getChartOptions("day-chart-categories", categories, true)
            } else {
          this.dayChartOptions = Chart.getChartOptions("day-chart-categories", categories)
            }
            this.dayChartSeries = Chart.getChartSeries("day-chart-series", series)
        },
        setHourChart () {
            let categories = []
            let series = []

            this.activeCampaignReport.displays_by_hour.map(obj=>{
                // let hour = this.setHourValue(obj.hour)
                categories.push(obj.hour)
                series.push(obj.duration)
            })
            if(this.isMobile()){
                const newCategories = categories.filter(function(value, index, categories) {
                    return index % 3 == 0;
                });
                this.hourChartOptions = Chart.getChartOptions("hour-chart-categories", newCategories, true)
            } else {
                this.hourChartOptions = Chart.getChartOptions("hour-chart-categories", categories)
            }

            this.hourChartSeries = Chart.getChartSeries("hour-chart-series", series)
        },
        setHourValue (hour) {
            if(hour === 0){
                return "12am"
            } else if (hour === 12) {
                return "12pm"
            } else if(hour > 12) {
                return (hour - 12) + "pm"
            } else {
                return hour + "am"
            }
        },
        initGeofenceMap () {
            this.polygons = []
            if(this.activeCampaign && this.activeCampaign.ZIP_codes && this.activeCampaign.ZIP_codes.length > 0){
                let self = this
                var url = '/get/ZIP_codes'
                var body = {
                    data: { zip_codes: this.activeCampaign.ZIP_codes }
                }

                this.request(url, 'POST', body).then(response=>{
                    if (response.code === 0) {
                        this.polygons = []
                        if(response.data.boundary === null || response.data.zip_codes.length === 0){
                            return
                        }
                        let coordinates = response.data.boundary.coordinates;

                        this.extractCoordinates(coordinates)
                        let self = this

                        let geofenceInterval = setInterval(() => {
                            if(self.geofenceMap){
                                self.geofenceMap.fitBounds(self.bounds)
                                clearInterval(geofenceInterval)
                            }
                        }, 50)
                    } else {
                        toast.errorMessage(response.message)
                        if (response.code === ERROR_CODE_INVALID_TOKEN) {
                            this.checkTokenConditions(this.initGeofenceMap)
                        }
                    }
                })
            } else {
                this.zoomCircle()
            }
        },
        zoomCircle () {
            let self = this;

            let interval = setInterval(() => {
                try{
                    if(self.$refs.theCircle && self.$refs.theCircle.$circleObject){
                        self.geofenceMap.fitBounds(self.$refs.theCircle.$circleObject.getBounds())
                        clearInterval(interval)
                    }
                } catch (error) {

                }
            }, 50)
        },
        extractCoordinates (coordinates, loop=false) {
            console.log(coordinates);
            if(!loop){
                this.polygons = []
                this.bounds = new this.google.maps.LatLngBounds()
            }

            if(typeof coordinates[0][0] === "number") {
                var polygon = []
                coordinates.map(pair=>{
                    let latLng = new this.google.maps.LatLng(pair[1], pair[0])
                    this.bounds.extend(latLng)
                    polygon.push({ lat: pair[1], lng: pair[0] })
                })
                this.polygons.push(polygon)
            } else {
                coordinates.map(pair=>{
                    this.extractCoordinates(pair, true)
                })
            }
        },
        setChart() {
            this.activeChartType = 'duration'
            this.activeChartDuration = 'days'
            this.changeChartData()
        },
        setFilteredChart() {
            this.filteredChartType = 'duration'
            this.filteredChartDuration = 'days'
            this.changeFilteredChartData()
        },
        setChartType(type){
            this.activeChartType = type
            this.changeChartData()
        },
        setChartDuration(duration){
            this.activeChartDuration = duration
            this.changeChartData()
        },
        setFilteredChartType(type){
            this.filteredChartType = type
            this.changeFilteredChartData()
        },
        setFilteredChartDuration(duration){
            this.filteredChartDuration = duration
            this.changeFilteredChartData()
        },
        changeChartData() {
            let categories = []
            let series = []
            this.totalChart =0

            this.chart[this.activeChartDuration].map(obj=>{
                categories.push(obj[this.activeChartDuration.replace("s", "")])
                series.push(obj[this.activeChartType])
                this.totalChart += obj[this.activeChartType]
            })

            this.chartSeries = Chart.getChartSeries("driver-chart-series", series)
            // $('.campaign__chart__container .chart__total__holder span').html(this.totalChart)

            if(this.isMobile()){

                this.chartOptions = Chart.getChartOptions("driver-chart-categories", categories, true)
            } else {
                this.chartOptions = Chart.getChartOptions("driver-chart-categories", categories)
            }
        },
        changeFilteredChartData(){
            let categories = []
            let series = []
            this.totalfilteredChart = 0

            this.filteredChart[this.filteredChartDuration].map(obj=>{
                categories.push(obj[this.filteredChartDuration.replace("s", "")])
                series.push(obj[this.filteredChartType])
                this.totalfilteredChart += obj[this.filteredChartType]
            })

            this.filteredChartSeries = Chart.getChartSeries("driver-chart-series", series)

            if(this.isMobile()){
                this.filteredChartOptions = Chart.getChartOptions("driver-chart-categories", categories, true)
            } else {
                this.filteredChartOptions = Chart.getChartOptions("driver-chart-categories", categories)
            }
        },
        startTimeChange (time) {
            this.filters.start_time = time
        },
        endTimeChange (time) {
            this.filters.end_time = time
        },
        campaignStatusChanger () {
            this.statusChange = true
            setTimeout(() => {
                document.getElementById('status-change').focus()
            }, 1000)
        },
        removeStatusBox () {
            setTimeout(() => {
                this.statusChange = false
                if (this.campaignApproval !== null){
                    var body = {
                        data: {
                            campaign_id: this.campaign.id,
                            status: this.campaignApproval ? 'approved' : 'declined'
                        }
                    }
                    this.request('/admin/set/campaign', 'POST', body).then(response => {
                        if (response.code === 0) {
                            toast.successMessage('Campaign status updated')
                            this.setupCampaign()
                        } else {
                            toast.errorMessage(response.message)
                            if (response.code === ERROR_CODE_INVALID_TOKEN) {
                                this.checkTokenConditions(this.removeStatusBox)
                            }
                        }
                    }).catch(error => {
                        toast.errorMessage(error)
                    })
                }
            }, 800)
        },
        // beforePrint () {
        //     $("#popupContainer").css("width", "100%");
        //     $('.chart').css("width", "100%");
        //     // export with SCALE (works on portrait and landscape)
        //     const chartss = document.getElementsByClassName("chart");
        //     //   $(".chart").css({"transform": "scale(0.8)", "transform-origin": "left"});
        //     chartss.forEach((element,index) => {
        //     element.firstChild.style.transform = 'scale(0.43)  transform-origin: left'
        //     });
        // },
        // afterPrint () {
        //     $("#popupContainer").css("width", "100%");
        //     // export with SCALE (works on portrait and landscape)
        //     const chartss = document.getElementsByClassName("chart");

        //     chartss.forEach((element,index) => {
        //     // element.firstChild.style.transform = 'scale(1.0)  transform-origin: left translate(0px, 0px)'
        //     });
        // },
        downloadReport () {
        //   console.log(window);
        //   if(window.matchMedia('print')){
        //     this.beforePrint();
        //     console.log('Media Print '+ true)
        //   }else{
        //     console.log('Media Print '+ false)
        //   }
             print($("#popupContainer"))
            //  this.afterPrint();
        },
        setCategories (categorieIndex) {
            var categoriesList = this.store.state.schema.categories
            for (let index = 0 ; index < categoriesList.length ; index++) {
                if (categoriesList[index].id === categorieIndex) {
                    return categoriesList[index].name
                }
            }
        },
        setCarType (car_type) {
            let string = ''
            var carType = this.store.state.schema.car_types
            for (let index = 0 ; index < carType.length ; index++) {
                if (car_type.includes(carType[index].id)) {
                    string += carType[index].type + ', '
                }
            }
            return string
        },
        approveCampaign () {
            this.campaignApproval = true
        },
        declineCampaign () {
            this.campaignApproval = false
        },
        checkTokenConditions (callback) {
            try{
                var expiresDate = new Date(this.token.expires)
            } catch (err) {
                this.$router.push('/login')
            }
            var now = new Date()
            if (expiresDate <= now) {
                this.store.commit('setToken', {})
                this.$router.push('/login')
            } else {
                var body = {
                code: '',
                refresh_token: this.token.refresh_token
                }
                this.request('/refresh/token', 'POST', body).then((response) => {
                if (response.code === 0 ) {
                    store.commit('setToken', response.data[0])
                    store.commit('setDriver', response.data[0].driver)
                    callback()
                } else if (response.code === ERROR_CODE_INVALID_TOKEN) {
                    this.store.commit('setToken', {})
                    this.$router.push('/login')
                }
                }).catch((error) => {
                })
            }
            var token = this.token
            token.redirect = false
            this.store.commit('setToken', token)
        },
        zoomChangingFilteredCampaignStats(zoom){
          this.getFilteredCampaignStats(zoom)
        },
        zoomChangingZipcodeHeatMap(zoom){
          this.getCampaignStats(zoom)
        },

    },
    props: {
        campaign: {
                type: Object,
                default: function () {
                    return {
                        lat: 34,
                        lng: 34,
                        distance: 10000,
                        ZIP_codes: []
                    }
                }
        }
    },
    mounted () {
        let self = this
        this.setupCampaign()
        this.$refs['geofenceMap'].$mapPromise.then((map) => {
            self.geofenceMap = map
        })
    },
    computed: {
        google: gmapApi,
        computedPolygons: function() {
            if(this.polygons.length > 0){
                return this.polygons
            } else {
                return []
            }
        },
        totalFixed:function(){
            // const number = Number.parseFloat(this.totalChart);
            // this.totalChart = (number.toFixed(3)).toString();
            if(this.totalChart % 1 == 0){
              return this.totalChart;
            }
            return this.totalChart.toFixed(2);

        }
    }
}
</script>

<style scoped>
@import '../../style/admin.css';

.v-spinner {
    margin-right: 10px;
}

.disabled-btn{
    background: rgb(229, 229, 229);
    border: none;
    cursor: not-allowed;
}

.popup__overlay{
    width: 100%;
    height: 100%;
    z-index: 99;
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    animation-name: show__popup;
    animation-duration: .3s;
    animation-fill-mode: forwards;
}

@keyframes show__popup{
    0%{
        opacity: 0;
        transform: scale(0);
    }

    100%{
        opacity: 1;
        transform: scale(1);
    }
}

.campaign__popup{
    position: relative;
    width: 100%;
    margin: 15px;
    height: 100%;
    z-index: 99;
    background: #fff;
    border-radius: 5px;
    box-sizing: border-box;
    padding: 15px;
    overflow-y: auto;
}

.control-btn-container .btn{
    color: #000;
    border-radius: 5px;
    display: flex;
    align-items: center;
    border: 1px solid #000;
    padding: 5px;
    margin: 5px;
    font-size: 14px;
    position: relative;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none;
}

.control-btn-container .btn p{
    padding: 0;
    margin: 0;
}

.control-btn-container .btn:hover{
    color: #2EA3FF;
    border: 1px solid #2EA3FF;
    cursor: pointer;
}

.control-btn-container .btn:hover .option-btn svg{
    color: #000;
}

.delete--btn{
    display: flex;
    align-items: center;
}

.control-btn-container .btn .btn-popup{
    position: absolute;
    top: 100%;
    border-radius: 5px;
    background: #fff;
    padding: 5px;
    right: 0px;
    border: 1px solid #000;
    margin-top: 5px;
    box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.25);
    cursor: pointer;
    display: flex;
    align-items: center;
}

.control-btn-container .btn .btn-popup p{
    margin: 0 20px 0 5px;
    padding: 0;
    min-width: 100px;
}

.control-btn-container .btn .btn-popup .option-btn{
    border: 1px solid #000;
    padding: 5px;
    margin: 5px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.control-btn-container .btn .btn-popup .option-btn svg{
    width: 14px;
    height: 14px;
    margin-right: 0;
}

.control-btn-container .btn .btn-popup .option-btn:hover{
    border: 1px solid #2EA3FF;
}

.control-btn-container .btn .btn-popup .option-btn:hover svg{
    color: #2EA3FF;
}

.control-btn-container .btn svg{
    margin-right: 5px;
}

.control-btn-container .btn:last-of-type{
    margin-right: 0;
}

.control-btn-container .btn:last-of-type svg{
    margin-right: 0;
}

.popup__header{
    text-align: left;
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    box-sizing: border-box;
}

.popup__header p{
    font-size: 16px;
}

.popup__header > span{
    background: #42DDA1;
    border-radius: 12px;
    font-size: 12px;
    text-transform: uppercase;
    color: #fff;
    padding: 5px 10px 5px 10px;
    margin-left: 20px;
    height: 12px;
    display: flex;
    align-items: center;
}

.campaign__overview{
    min-height:  100px;
    padding: 15px;
    margin-top: 25px;
    margin-bottom: 25px;
}

.campaign__top__row{
    display: flex;
    margin-top: 15px;
}

.campaign__bottom__row{
    text-align: left;
}
.campaign_left{
    float:left;
     max-width:30%;
     width:30%;
     height:160px;
 margin-right:5%;
  margin-right:3%;
 }
 .campaign_left img,
 .campaign_left video{
    width: 100%;
     height: 100%;
     object-fit: contain;
     padding:10px 0;
   margin-top: -5%;
  }

.campaign__bottom__row .label{
    margin: 0;
    padding: 0;
    font-weight: bold;
    font-size: 12px;
    text-transform: uppercase;
    text-align: left;
    margin-top: 10px;
}

.campaign__bottom__row .campaign__pair__holder{
    display: flex;
}

.campaign__bottom__row .campaign__pair{
    margin-right: 15px;
}

.campaign__bottom__row .campaign__pair p{
    text-align: left;
    font-size: 14px;
}

.campaign__top__row .campaign__pair{
   min-width: 28%;
}
.campaign__bottom__row .campaign__pair{
   min-width: 26%;
}

.campaign__top__row .campaign__pair .label{
    margin: 0;
    padding: 0;
    font-weight: bold;
    font-size: 12px;
    text-transform: uppercase;
    text-align: left;
}

.campaign__top__row .campaign__pair .value{
    font-size: 14px;
    font-weight: normal;
    text-align: left;
}

.box-shadow{
    border-radius: 5px;
    box-shadow: 0px 0px 10px rgba(15, 32, 47, 0.5);
}

.boxes__container{
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
}

.box__container {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  text-align: left;
  padding: 0 15px 15px 15px;
}

.box__container img{
    width: 35px;
    height: 60px;
}

.box__container .label{
    margin: 0;
    padding: 0;
    font-weight: bold;
    font-size: 10px;
    text-transform: uppercase;
}

.box__container .value{
  display: flex;
  flex-direction: column;
  justify-content: end;
  flex: 1 1 auto;
  margin: 0;
  padding: 0;
  font-weight: 500;
  font-size: 20px;
  margin-top: 15px;
}

.box__container:nth-of-type(1){
    margin-left: 0;
}

.box__container:nth-of-type(6){
    margin-right: 0;
}

.overview__header{
    margin: 0 0 10 0;
    padding: 0;
    font-weight: bold;
    font-size: 12px;
    text-transform: uppercase;
    text-align: left;
}

.charts__row{
    display: flex;
}

.chart__container{
    margin: 15px;
    width: 50%;
}

.chart{
    box-shadow: 0px 0px 15px rgba(181, 181, 181, 0.412);
    border-radius: 15px;
}

.chart__container p{
    text-align: left;
    font-size: 12px;
    text-transform: uppercase;
}

.charts__header{
    margin: 15px 15px 0 15px;
    padding: 0;
    font-weight: bold;
    font-size: 12px;
    text-transform: uppercase;
    text-align: left;
    padding-top: 15px;
}
.chart__total__holder{
    position:absolute;
    left:0;
    display: block;
    margin-top: 5px;
}
.chart__total__holder span{
    font-weight: 600;
    margin-left: 5px;
}

.maps__container{
    margin-top: 25px;
    margin-bottom: 25px;
    box-sizing: border-box;
}

.heatmap__container .chart__container{
    width: calc(100% - 15px);
}

.report-btn{
    float:right;
    border: 1px solid #000;
    border-radius: 5px;
    margin-right:15px;
    padding: 8px;
    color: #000;
    font-size: 12px;
    display: flex;
    align-items: center;
}

.report-btn:hover{
    color: #2EA3FF;
    border: 1px solid #2EA3FF;
    cursor: pointer;
}

.report-btn svg{
    margin-right: 5px;
    height: 14px;
    width: 14px;
}

p{
    color: #000;
}

.filters__container .header{
    text-align: left;
}

.campaign__chart__container {
    flex-direction: column;
    padding: 15px;
    margin-bottom: 25px;
    margin-top: 85px;
}

.filtered__map__container{
    width: 100%;
    height: 300px;
    position: relative;
}

.filtered__chart__container{
    position: relative;
}

.chart__labels__holder{
    margin-bottom: 15px;
}


.status__context{
    width: 212px;
    height: 30px;
    position: relative;
    top: 33px;
    z-index: 9999;
}

.status__style{
    background: #FFFFFF;
    margin-bottom: 11px;
    text-align: center;
    padding: 9px 0px 27px 0px;
}

.status__border{
    border: 2px solid #000000;
    box-sizing: border-box;
    box-shadow: 10px 10px 5px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
}

.button__style{
    margin-left: 10px;
    margin-right: 10px;
    padding-left: 4px;
    padding-right: 4px;
}

.button__context{
    border: 1px solid;
    border-radius: 10px;
    cursor: pointer;
}

.btn__approve__campaign__color{
    border-color: #42DDA1;
}

.btn__decline__campaign__color{
    border-color: #E16D6F;
}

.btn__approve__clicked {
    background: #42DDA1;
    color: #fff;
}

.btn__decline__clicked {
    background: #E16D6F;
    color: #fff;
}

.admin-campaign-heatmap {
  width: 50%;
  margin: 15px;
  height: 300px;
}

.campaigns-stats-heatmap {
  width: 100%;
  height: 300px;
}

@media only screen and (max-width: 600px) {
    .btn p{
        display: none;
    }

    .overview__header{
        margin-bottom: 10px;
    }

    .control-btn-container .btn svg{
        margin-right: 0;
    }

    .popup__header p {
        font-size: 12px;
    }

    .boxes__container {
        flex-wrap: wrap;
    }

    .box__container {
        margin-left: 0;
    }

    .box__container:nth-of-type(even){
        margin-right: 0;
    }

    .campaign__top__row {
        flex-wrap: wrap;
    }

    .campaign__top__row .campaign__pair {
        margin-right: 15px;
    }

    .charts__row {
        flex-direction: column;
    }

    .chart__container {
        width: 100%;
        padding: 2px;
        margin: 0 !important;
    }

    .chart{
        width: 100%;
        overflow-x: auto;
        overflow-y: hidden;
    }

    .chart__container p {
        font-size: 12px;
    }

    .maps__container{
        flex-direction: column;
        padding: 15px;
    }

    .vue-map-container{
        width: 100% !important;
    }

    .maps__container .vue-map-container{
        margin: 15px 0 0 0 !important;
    }

    .chart__labels__holder{
        flex-direction: column;
    }

    .chart__duration__holder{
        display: flex;
        margin: 15px 0 15px 0;
        position: relative;
    }

    .chart__labels__holder p{
        font-size: 10px;
    }

    .filters__row {
        flex-direction: column;
    }

    .filters__row .time__container, .heatmap__container .filters__container .filters__row .datepicker {
        width: 100% !important;
        margin-right: 0;
        margin-left: 0;
    }

    .double__chart .chart__container{
        padding: 15px;
        box-sizing: border-box;
    }

    @media only screen and (max-width: 600px) {
        .status__style {
            margin-left: 100px;
            margin-top: -11px;
        }
    }
}
@media screen and (max-width:890px) and (min-width: 600px) {
      .chart__labels__holder{
        flex-direction: column;
    }

    .chart__type__holder{
      margin-top:12%;
      margin-left: auto;
      margin-right:auto ;
    }

    .chart__duration__holder{
        display: flex;
        margin-left:auto;
        margin-right:auto;
        position: relative;
        margin-top:2%;
    }

    .chart__total__holder{
        margin-left:40%;
        margin-top:-25%;
    }

    .chart__labels__holder p{
        font-size: 13px;
    }
    }
    @media screen and (max-width:599px) {
      .chart__type__holder{
      margin-top:20%;
      margin-left: 0;
      margin-right:auto ;
    }
     .chart__total__holder{
        margin-left:0;
        /* margin-top:-40%;
         */
         top:13%;
    }


    .chart__duration__holder{
      margin-left: auto;
      margin-right: auto;
    }
    .chart__labels__holder p{
        font-size: 13px;
    }

    }
    @media screen and (min-width:700px)and (max-width: 889px){
     .chart__type__holder{
      margin-top:8%;
      margin-left: auto;
      margin-right:auto ;
    }
     .chart__total__holder{
        margin-left:40%;
        margin-top:-17%;
    }
    }

    @media screen and (max-width: 1100px) and (min-width:600px) {
       .filters__row{
         display: block;
       }
    }

    @media screen and (min-width: 1100px){
       .filters__row{
         display: inline-flex;
       }


    }
 @media screen and (min-width:600px) and (max-width: 890px) {
     .chart__total__holder{
         margin-left: 5px !important;
            margin-top: -19%;
     }
     .chart__type__holder{
         margin-left:0;
         margin-top: 12%
     }
     .chart__duration__holder{
         margin-left:0 !important;
     }
     .overview__header{
         margin-left:5px;
     }
     .filtered__chart__container.chart__container{
         margin-left: 0;
     }

 }

 /* Landscape */
@media only screen
  and (min-device-width: 375px)
  and (max-device-width: 667px)
  and (-webkit-min-device-pixel-ratio: 2)
  and (orientation: landscape) {

    .box__container:nth-of-type(3){
        margin-right: 0;
    }
    .box__data__mobile .box__context__text p{
        font-size: 85% !important;
    }
}



</style>
